import { render, staticRenderFns } from "./userStatisticsDetail.vue?vue&type=template&id=eb609284&scoped=true&"
import script from "./userStatisticsDetail.vue?vue&type=script&lang=js&"
export * from "./userStatisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./userStatisticsDetail.vue?vue&type=style&index=0&id=eb609284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb609284",
  null
  
)

export default component.exports